import React from "react"
import './style.css'
import { Pagination } from "antd"

    const CustomPagination = (props) => {
        const { className, ...otherProps } = props
        return (<Pagination
            className={`custom__pagination ${className}`}
            {...otherProps}
        > 

        </Pagination>)
    }

    export default CustomPagination